import { AppText, Card, styled } from '@streem/ui-react';

export const UnsupportedBrowserInfoCard = (): JSX.Element => {
    return (
        <div
            style={{
                display: 'flex',
                flexGrow: 1,
            }}
        >
            <Card
                decoratorPosition="side"
                style={{
                    margin: '0 20px',
                    alignSelf: 'center',
                }}
            >
                <AppText>
                    Want a preview? You can preview this video without audio by using Google Chrome.{' '}
                    <GetChromeLink
                        href="https://www.google.com/chrome/"
                        rel="noopener noreferrer"
                        target="_blank"
                        data-testid="get-chrome-link"
                    >
                        Get Chrome here.
                    </GetChromeLink>
                </AppText>
            </Card>
        </div>
    );
};

const GetChromeLink = styled('a')`
    text-decoration: none;
    color: ${props => props.theme.colors.azure};

    &:visited {
        color: ${props => props.theme.colors.azure};
    }
`;
